module.exports = __webpack_public_path__ + "img/andreja_rausl_part_1.png";